var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('v-row',[_c('div',{staticClass:"titulo2"},[_c('h1',[_vm._v("Pase de Abordar")])]),_c('div',{staticClass:"back"},[_c('router-link',{attrs:{"to":"/busqueda"}},[_c('button',[_c('Back')],1)])],1)])],1),_c('div',[_c('BoletoFactura',{attrs:{"boleto":_vm.boleto}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }